import { render } from "./RejectLeaveRequestModal.vue?vue&type=template&id=45b478a0"
import script from "./RejectLeaveRequestModal.vue?vue&type=script&lang=js"
export * from "./RejectLeaveRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__